import React, { useEffect, useState } from 'react';
import * as api from '~/Services/Service';

const DetalhesContraproposta = ({ infoContraproposta }) => {
  if (infoContraproposta == null) {
    return <p>Carregando informações...</p>;
  }

  return (
    <div className="mt-1">
      <h4>Informações da Proposta</h4>
      {infoContraproposta.map((linha, index) => (
        <span key={index}>
          {linha}
          <br />
        </span>
      ))}
    </div>
  );
};

export default DetalhesContraproposta;
